import React, { memo } from 'react';

type Props = {
  brand: string;
  accent: string;
};

export const Crew = memo(({ brand, accent }: Props) => (
  <svg className="FreeTrial__Crew" viewBox="0 0 360 240" aria-hidden="true">
    <ellipse cx="180" cy="228" rx="160" ry="9" fill="#19214d" fillOpacity=".08" />
    <g>
      <rect x="76" y="150" width="12" height="74" rx="6" fill="#2b3157" />
      <rect x="92" y="150" width="12" height="74" rx="6" fill="#2b3157" />
      <ellipse cx="82" cy="225" rx="10" ry="5" fill="#19214d" />
      <ellipse cx="98" cy="225" rx="10" ry="5" fill="#19214d" />
      <rect x="66" y="84" width="48" height="74" rx="18" fill={brand} />
      <rect x="70" y="138" width="40" height="46" rx="6" fill={accent} />
      <rect x="56" y="90" width="13" height="40" rx="6.5" fill={brand} />
      <rect x="56" y="118" width="30" height="13" rx="6.5" fill={brand} />
      <rect x="111" y="90" width="13" height="40" rx="6.5" fill={brand} />
      <rect x="94" y="118" width="30" height="13" rx="6.5" fill={brand} />
      <rect x="84" y="70" width="12" height="18" fill="#f1c7a3" />
      <circle cx="90" cy="33" r="9" fill="#3b2416" />
      <circle cx="90" cy="56" r="20" fill="#f1c7a3" />
      <path d="M70 58C70 36 110 36 110 58C106 47 97 43 90 45C82 43 74 47 70 58Z" fill="#3b2416" />
    </g>
    <g>
      <rect x="166" y="146" width="12" height="78" rx="6" fill="#2b3157" />
      <rect x="182" y="146" width="12" height="78" rx="6" fill="#2b3157" />
      <ellipse cx="172" cy="225" rx="10" ry="5" fill="#19214d" />
      <ellipse cx="188" cy="225" rx="10" ry="5" fill="#19214d" />
      <rect x="156" y="72" width="48" height="80" rx="18" fill={brand} />
      <rect x="146" y="78" width="13" height="58" rx="6.5" fill={brand} />
      <rect x="201" y="78" width="13" height="58" rx="6.5" fill={brand} />
      <path d="M164 112L170 76M196 112L190 76" stroke={accent} strokeWidth="3" />
      <rect x="160" y="110" width="40" height="72" rx="6" fill={accent} />
      <rect x="174" y="58" width="12" height="18" fill="#8d5a3b" />
      <circle cx="180" cy="44" r="20" fill="#8d5a3b" />
      <path d="M160 44C160 21 200 21 200 44C196 33 188 29 180 30C172 29 164 33 160 44Z" fill="#161616" />
    </g>
    <g>
      <rect x="256" y="150" width="12" height="74" rx="6" fill="#2b3157" />
      <rect x="272" y="150" width="12" height="74" rx="6" fill="#2b3157" />
      <ellipse cx="262" cy="225" rx="10" ry="5" fill="#19214d" />
      <ellipse cx="278" cy="225" rx="10" ry="5" fill="#19214d" />
      <rect x="246" y="84" width="48" height="74" rx="18" fill={brand} />
      <rect x="236" y="90" width="13" height="58" rx="6.5" fill={brand} />
      <rect x="250" y="118" width="40" height="66" rx="6" fill={accent} />
      <rect x="264" y="70" width="12" height="18" fill="#d9a27e" />
      <circle cx="270" cy="52" r="25" fill="#4a2a1d" />
    </g>
  </svg>
));
